module.exports = __webpack_public_path__ + "static/media/addIcon.af0b1411.svg";